import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { PermissionList, renderStaffName, RolePermission, SaveParams, staffStatusEnums, useModal } from 'utils';
import { AddButton, DateTypeSelector, DownloadCsv, FilterPopover, SelectAutocompletePaginationMultiple } from 'components';
import { TimeSheetModalSelector } from 'fragments';
import { TIMESHEET_POPOVER_KEYS } from './timeSheetSelectedFilters';

export const ActiveTimeSheetFilter = ({}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const { open } = useModal();
    const activeFiltersCount = (info?.staffs?.length ? 1 : 0) + (info?.start || info?.end ? 1 : 0);

    const handleChange = (e) => {
        const newFilters = {
            ...info,
        };
        newFilters.page = 1;
        newFilters.skip = 0;

        if (e?.target?.value === 'All') {
            delete newFilters[e.target.name];
        } else {
            newFilters[e.target.name] = e.target.value;
            if (e.target.name === 'staffs') {
                newFilters[e.target.name === 'staffs' ? 'staffFull' : ''] = e.target?.full;
            }
        }
        SaveParams(navigate, { ...newFilters });
    };

    const handleResetAll = (handleClose) => {
        const params = { ...info, skip: 0, page: 1 };
        TIMESHEET_POPOVER_KEYS.forEach((k) => delete params[k]);
        SaveParams(navigate, params);
        handleClose?.();
    };

    return (
        <div className="flex-align-center" style={{ alignItems: 'flex-end', gap: 16 }}>
            <div className="flex-align-end" style={{ gap: 16 }}>
                <FilterPopover activeFiltersCount={activeFiltersCount} onResetAll={handleResetAll}>
                    <SelectAutocompletePaginationMultiple
                        inputStyles={{width:'100%'}}
                        defaultStatuses={[staffStatusEnums.ACTIVE]}
                        outLabel={'Staff'}
                        uiType={'tableFilter'}
                        placeholder={info?.staffFull?.length ? info?.staffFull?.map((i) => renderStaffName(i)).join(', ') : 'All'}
                        name={'staffs'}
                        handleSelect={handleChange}
                        defaultValue={info?.staffFull ? info?.staffFull : []}
                        renderValue={(i) => renderStaffName(i)}
                        type={'staff'}
                        noError={true}
                    />
                    <DateTypeSelector startName={'start'} endName={'end'} outLabel={'DOS'} />
                </FilterPopover>
            </div>

            <div className={'export-csv-box'}>
                <DownloadCsv fromModal={true} type={'activePayroll'} />
                {RolePermission([PermissionList.PAYROLL_MANAGE?.code]) && (
                    <AddButton text="Add Timesheet" handleClick={() => open(<TimeSheetModalSelector blockSuccess={true} />)} />
                )}
            </div>
        </div>
    );
};
